import React, {useEffect, useRef, useState} from 'react';
import {useActions} from "../../redux/actions";
import {Loader, Dimmer, Grid} from "semantic-ui-react";
import {Calendar, momentLocalizer} from 'react-big-calendar'
import moment from 'moment'
import {connect} from "react-redux";
import {RootState} from "../../model";
import {Referral} from '../../model/referral';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {PracticeList} from '../../model/practice';
import * as practiceActions from "../../redux/actions/practice";
import * as referralActions from "../../redux/actions/referrals";
import * as billingActions from '../../redux/actions/billing';
import OralReferIn from "../../styles/images/oral-in.png";
import OralReferOut from "../../styles/images/oral-out.png";
import OrthoRefOut from "../../styles/images/ortho-out.png";
import OrthoRefIn from "../../styles/images/ortho-in.png";
import {capitalizeFirstLetters, findPractice} from '../../utils/common';
import ReferralDetailsModal from './ReferralDetailsModal';
import * as statusActions from "../../redux/actions/oralSurgeryStatuses";
import * as reportActions from "../../redux/actions/report";
import * as Actions from "../../redux/actions/userSetup";
import CustomToolBar from '../CustomToolBar';
import {SetupFields} from '../../enums/userSetpField';
import {SetupAppName} from '../../enums/userSetup';
import {UserSetup} from '../../model/userSetup';
import ReferralsFilters from "./ReferralsFilters";

const localizer = momentLocalizer(moment)

interface ReferralsProps {
    referrals: Array<Referral>;
    practiceList: Array<PracticeList>;
    practiceListAll: Array<PracticeList>;
    production: any;
    familyData: any;
    auth: any;
    userSetup: UserSetup;
}

const Referrals = (props: ReferralsProps) => {
    const practiceAction = useActions(practiceActions);
    const referralAction = useActions(referralActions);
    const billingAction = useActions(billingActions);
    const StatusActions = useActions(statusActions);
    const userSettingsActions = useActions(Actions);
    const reportAction = useActions(reportActions);
    const [oralSurgeryStatus, setOralSurgeryStatus] = useState({});
    let reportData: any = [];
    const initialState: any = {
        referralModal: false,
        detailsModalType: '',
        detailsModal: false,
        eventClick: false,
        eventDate: false,
        productionPrice: false,
        practicePriceList: false,
        startDate: moment().format('Y-MM-01'),
        todayProduction: {},
        filterPractice: 'All',
        selectedPT_Num: null,
        stateHistory: null,
        openStatusDropdown: false,
        statusList: {},
        type: 'all'
    };
    const [state, setState] = useState(initialState);
    const isMounted = useRef(false);


    useEffect(() => {
        setData()
    }, []);

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        if(!state.detailsModal) fetchReferrals();
    }, [state.detailsModal]);

    const fetchReferrals = () => {
        let params = {
            startDate: state.startDate,
            endDate: moment(state.startDate, "YYYY-MM-DD").endOf('month').format('Y-MM-DD'),
            filterPractice: state.filterPractice,
            type: state.type
        }
        practiceAction.fetchPractices();
        referralAction.allReferral(params);
    }

    const setData = async () => {
        let userSetup = props.userSetup;
        const practiceListAll = await practiceAction.fetchAllPractices({type: 'all'});
        if (!props.userSetup.value) {
            let userParams = {field: SetupFields.Practice, appId: SetupAppName.FIELD};
            userSetup = await userSettingsActions.getSetup(userParams);
        }
        let params = {
            startDate: state.startDate,
            endDate: moment(state.startDate, "YYYY-MM-DD").endOf('month').format('Y-MM-DD'),
            filterPractice: state.filterPractice,
            type: state.type
        }
        if (userSetup && userSetup.value !== undefined) {
            let defaultPractices: string[] = [];
            if (userSetup.value !== 'all') {
                defaultPractices = userSetup.value.split(',')
                    .filter((practiceOption: string) => practiceOption !== 'all')
                    .map((practiceOption: string) => {
                        return (findPractice(practiceListAll, practiceOption) || {practice: 'all'}).practice;
                    });
            } else {
                defaultPractices = ['all'];
            }
            params.filterPractice = defaultPractices;
            setState({...state, defaultPractices})
        }

        setState({...state, filterPractice: params.filterPractice});
        practiceAction.fetchPractices();
        referralAction.allReferral(params);

        const queryParams = new URLSearchParams(window.location.search);
        const practice = queryParams.get("practice");
        const practiceName = queryParams.get("practiceName");
        const selectedPT_Num = queryParams.get("selectedPT_Num");

        if (practice && practiceName && selectedPT_Num) {
            setTimeout(() => billingAction.openFamilyView(selectedPT_Num, practice, practiceName), 5.0 * 1000);
        }
    }

    const eventTitle = (type: string, price: number) => {
        return <div className="d-flex" style={{backgroundColor: "#FFFFFF", color: "#000000"}} id={type}>
            <span>{capitalizeFirstLetter(type)}</span>
            <b className="label-referral">{price}</b> <br/>
        </div>;
    }

    const capitalizeFirstLetter = (s: string) => {
        if (s === 'oralRefOut') {
            return (<img alt="" className="cursorPointer" src={OralReferOut}/>);
        } else if (s === 'orthoRefOut') {
            return (<img alt="referin" className="cursorPointer" src={OrthoRefOut}/>);
        } else if (s === 'orthoRefIn') {
            return (<img alt="oralRefOut" className="cursorPointer" src={OrthoRefIn}/>);
        } else if (s === 'oralRefIn') {
            return (<img alt="oralRefIn" className="cursorPointer" src={OralReferIn}/>);
        } else {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }

    }

    const sortCalendarBillingList = (referralData: any) => {
        let returnSortList: any = []
        const types = ['orthoRefOut', 'oralRefOut', 'oralRefIn', 'orthoRefIn'];


        const indexKey = 'production';
        if (Object.keys(referralData[indexKey]).length && Object.keys(referralData[indexKey].orderByDate).length) {
            Object.keys(referralData[indexKey].orderByDate).forEach((dateKey) => {
                const item = referralData[indexKey].orderByDate[dateKey];
                types.forEach(type => {
                    if (item[type]) {
                        returnSortList.push({
                            id: dateKey,
                            type: type,
                            price: item[type],
                            title: eventTitle(type, item[type]),
                            allDay: true,
                            start: moment(dateKey + ' 13:00:00'),
                            end: moment(dateKey + ' 13:00:00'),
                            hoverTitle: capitalizeFirstLetters(type, item[type])
                        });
                    }
                });
            });
        }

        return returnSortList;
    }
    let calendarBillingList = [];
    if (Object.keys(props.production).length > 0) {
        calendarBillingList = sortCalendarBillingList(props);
    }

    const onSelectEvent = (event: any, type = 'report', eventClick = 'day') => {
        let stateObj = {
            detailsModal: type,
            detailsModalType: event.type,
            eventClick: eventClick,
            eventDate: event.id,
            productionPrice: 0
        }
        if (event.price)
            stateObj.productionPrice = event.price
        setState({
            ...state,
            detailsModal: type,
            detailsModalType: event.type,
            eventClick: eventClick,
            eventDate: event.id,
            productionPrice: stateObj.productionPrice
        });
    }

    const onNavigate = (selectedDate: any) => {
        const startDate = moment(selectedDate).format('Y-MM-01');
        const currentMonth = moment().format('Y-MM-01');
        if ((state.startDate != startDate && currentMonth >= startDate)) {
            let params = {
                startDate: startDate,
                endDate: moment(selectedDate).endOf('month').format('Y-MM-DD'),
                filterPractice: state.filterPractice
            }
            setState({...state, startDate: startDate});
            referralAction.allReferral(params);
        }
    }

    const openFamilyView = async (selectedPT_Num: any, practice: any, practiceName: any) => {
        if (state.selectedPT_Num !== selectedPT_Num || state.selectedPractice !== practice){
            setState({ ...state, loading: true });
            await billingAction.getFamilyPatients(selectedPT_Num, practice);
        }

        const stateObj = {
            detailsModal: 'familyView',
            detailsModalType: 'familyView',
            selectedPT_Num: selectedPT_Num,
            selectedPractice: practice,
            selectedPracticeName: practiceName
        }
        if (state.stateHistory !== null && state.stateHistory !== undefined && (!state.stateHistory[state.stateHistory.length - 1] ||
            state.stateHistory[state.stateHistory.length - 1].detailsModalType !== 'familyView'))
            state.stateHistory.push(stateObj);
        setState({
            ...state,
            loading: false,
            detailsModalType: 'familyView',
            selectedPT_Num: selectedPT_Num,
            selectedPractice: practice,
            selectedPracticeName: practiceName,
            stateHistory: state.stateHistory
        });
    }

    const changeTab = (selectedPT_Num: any) => {
        if (state.selectedPT_Num !== selectedPT_Num)
            billingActions.getFamilyPatientDetails(selectedPT_Num, state.selectedPractice);
        setState({...state, 'selectedPT_Num': selectedPT_Num});
    }

    const hideDetailsModal = () => {
        setState({...state, detailsModal: false, detailsModalType: false, referralModal: false});
    }

    const getMonthlyData = (type: string, ignore?: boolean) => {
        StatusActions.fetchOralSurgeryStatus().then((res: any) => {
            setOralSurgeryStatus(res);
        });
        if(ignore) return;
        setState({...state,openStatusDropdown: false, detailsModal: 'report', detailsModalType: type, eventClick: 'month'});
    }

    const sendReport = (typeData: [], name: string, detailsModalType: string, title: string) => {
        const filterData = {
            typeData: typeData,
            name: name,
            detailsModalType: detailsModalType,
            title: title
        }
        reportAction.sendReferStatsReportDetails(filterData);
    };

    const onChangeFilter = (filters: any) => {
        setState({...state, type: filters.type})
        let params = {
            startDate: state.startDate,
            endDate: moment(state.startDate, "YYYY-MM-DD").endOf('month').format('Y-MM-DD'),
            filterPractice: filters.practice,
            type: filters.type
        }
        setState({...state, filterPractice: filters.practice, type: filters.type})
        referralAction.allReferral(params);
    };

    if (props.production.reportData) {
        reportData = props.production.reportData
    }


    return (
        <div className="calendar-container">
            <Dimmer active={state.loading} inverted={true}>
                <Loader inverted={true}/>
            </Dimmer>
            {(state.detailsModal) && <ReferralDetailsModal
                detailsModalType={state.detailsModalType}
                hideDetailsModal={hideDetailsModal}
                detailsModal={state.detailsModal}
                onSelectEvent={onSelectEvent}
                sendReport={sendReport}
                reportData={reportData}
                eventClick={state.eventClick}
                eventDate={state.eventDate}
                productionPrice={state.productionPrice}
                startDate={state.startDate}
                showPracticeList={state.showPracticeList}
                practicePriceList={state.practicePriceList}
                todayProduction={state.todayProduction}
                practiceList={props.practiceListAll}
                openFamilyView={openFamilyView}
                selectedPractice={state.selectedPractice}
                selectedPT_Num={state.selectedPT_Num}
                selectedPracticeName={state.selectedPracticeName}
                changeTab={changeTab}
                familyData={props.familyData}
                statuses={oralSurgeryStatus}
                auth={props.auth}
            />}
            <Grid>
                <Grid.Row>
                    <Grid.Column width={5}>
                        <h1>All Referrals</h1>
                    </Grid.Column>
                    <Grid.Column width={11}>
                        <ReferralsFilters
                            production={props.production}
                            practiceListAll={props.practiceListAll}
                            onChangeFilter={onChangeFilter}
                            getMonthlyData={getMonthlyData}
                            oralSurgeryStatus={oralSurgeryStatus}
                            defaultPractices={state.defaultPractices}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <div className="ui card">
                <div className="content">
                    <Calendar
                        onSelectEvent={event => onSelectEvent(event)}
                        localizer={localizer}
                        events={calendarBillingList}
                        startAccessor="start"
                        endAccessor="end"
                        tooltipAccessor="hoverTitle"
                        onNavigate={onNavigate}
                        popup={true}
                        showMultiDayTimes={false}
                        defaultDate={new Date(moment().startOf('month').toString())}
                        style={{height: 720}}
                        components={{toolbar: CustomToolBar}}
                    />
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state: RootState) {
    return {
        referrals: state.referrals.production,
        production: state.referrals.production,
        practiceList: state.practice.practiceList,
        userSetup: state.userSetup,
        practiceListAll: state.practice.practiceListAll,
        familyData: state.billing.familyData,
        auth: state.auth,
    };
}

export default connect(mapStateToProps)(Referrals);
